module.exports = __webpack_public_path__ + "static/media/henri.d2432be1.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/henri.webp
// module id = 843
// module chunks = 0